import styled from '@emotion/styled';
import React, { useState } from 'react';
import { mergeProps, useButton, useFocus } from 'react-aria';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';
import { HomeyIcon } from '../../../components/common/HomeyIcon';

export function DeviceSettingsGeneralIconSelectPreview(props) {
  const { previewRef, select, state, onBlur } = props;

  const button = useButton(select.triggerProps, previewRef);

  const [isFocused, setIsFocused] = useState(false);
  const focus = useFocus({
    onFocusChange: setIsFocused,
    onBlur,
  });

  return (
    <S.Input
      {...mergeProps(button.buttonProps, focus.focusProps)}
      ref={previewRef}
      title={state.selectedItem?.textValue}
      data-is-open={state.isOpen}
      data-is-focused={isFocused}
    >
      <S.Span {...select.valueProps}>
        {state.selectedItem?.value.textValue === 'default' ? (
          <HomeyIcon
            iconObj={state.selectedItem?.value.icon}
            size={theme.icon.size_default}
            color={theme.color.icon_dark}
          />
        ) : (
          <S.SelectedIcon
            source={state.selectedItem?.value.icon}
            size={theme.icon.size_default}
            color={theme.color.icon_dark}
          />
        )}
      </S.Span>
      <S.ChevronDownIcon
        source={glyph.core.chevronDownBold}
        color={theme.color.icon_light}
        size={theme.icon.size_small}
      />
    </S.Input>
  );
}

function S() {}
DeviceSettingsGeneralIconSelectPreview.S = S;

S.Input = styled.button`
  position: relative;
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;
  grid-gap: ${su(1)};
  min-width: 0;
  width: 100%;
  height: 37px;
  padding: 6px ${su(1)};
  background-color: ${theme.color.component};
  border: 1px solid transparent;
  outline: 0;
  cursor: pointer;
  border: 1px solid ${theme.input.border};
  border-radius: ${theme.input.border_radius};

  &[data-is-open='true'],
  &[data-is-focused='true'] {
    border: 1px solid ${theme.input.border_focus};
  }
`;

S.Span = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
`;

S.SelectedIcon = styled(Glyph)``;

S.ChevronDownIcon = styled(Glyph)`
  flex: 0 0 ${theme.icon.size_tiny};
`;
